import { DateTime } from "luxon";

export const createTimeFilters = (time: string) => {
  const today = DateTime.now();
  let timeOffset = null;

  if (time === "day") {
    timeOffset = 1;
  } else if (time === "week") {
    timeOffset = 7;
  } else if (time === "month") {
    timeOffset = 30;
  } else if (time === "year") {
    timeOffset = 365;
  }
  if (timeOffset) {
    return {
      created_at_after: today.minus({ days: timeOffset }),
      created_at_before: today,
    };
  }
  return {};
};
